
import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140 mt-5">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                src={hicon} alt="" />FAQ</div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Dúvidas Frequentes</h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="1" className='acc-btn'><span className="number me-3">01</span>Quanto tempo leva para migrar nossa infraestrutura para a nuvem?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="content">
                                            <p>Em média, nossos clientes completam a migração em 2-4 semanas, dependendo da complexidade da infraestrutura. Garantimos zero downtime durante todo o processo. Os fatores que influenciam o tempo incluem:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Volume de dados e aplicações a migrar</li>
                                                <li><i className="far fa-check"></i>Complexidade dos sistemas integrados</li>
                                                <li><i className="far fa-check"></i>Necessidade de customizações específicas</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="2" className='acc-btn'><span className="number me-3">02</span>Qual é a economia real comparado aos provedores internacionais?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="content">
                                            <p>Nossos clientes economizam entre 30-50% comparado aos provedores internacionais, considerando câmbio e custos ocultos. Os benefícios incluem:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Preços fixos em Real sem variação cambial</li>
                                                <li><i className="far fa-check"></i>Sem taxas de transferência internacional</li>
                                                <li><i className="far fa-check"></i>Suporte técnico nacional incluso</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="3" className='acc-btn'><span className="number me-3">03</span>Como funciona o suporte técnico 24/7?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="content">
                                            <p>Oferecemos suporte técnico especializado 24/7 em português, com equipe certificada e tempo de resposta garantido:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Resposta em até 15 minutos para emergências</li>
                                                <li><i className="far fa-check"></i>Acesso direto aos especialistas sem call center</li>
                                                <li><i className="far fa-check"></i>Suporte presencial quando necessário</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="4" className='acc-btn'><span className="number me-3">04</span>Vocês atendem empresas de grande porte?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="content">
                                            <p>Sim! Atendemos desde startups até grandes corporações. Nossa infraestrutura suporta qualquer escala de operação:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Soluções escaláveis automaticamente</li>
                                                <li><i className="far fa-check"></i>Compliance para setores regulados</li>
                                                <li><i className="far fa-check"></i>SLA personalizado para cada cliente</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="5" className='acc-btn'><span className="number me-3">05</span>Como garantem a segurança dos nossos dados?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <div className="content">
                                            <p>Implementamos as mais rigorosas práticas de segurança, incluindo compliance total com LGPD:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Criptografia end-to-end de todos os dados</li>
                                                <li><i className="far fa-check"></i>Backup automatizado com múltiplas localizações</li>
                                                <li><i className="far fa-check"></i>Auditoria contínua e relatórios de segurança</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default FaqSection;
